import { useEffect, useState } from "react";

// Detects touch-first devices (phones/tablets) vs. laptops/desktops.
// Uses pointer: coarse (no fine mouse) OR presence of touch events.
const detect = () => {
  if (typeof window === "undefined") return false;
  const coarse = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
  const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const noHover = window.matchMedia && window.matchMedia("(hover: none)").matches;
  return !!(coarse && hasTouch) || (hasTouch && noHover);
};

export function useIsTouch() {
  const [touch, setTouch] = useState(detect);

  useEffect(() => {
    if (!window.matchMedia) return;
    const mqs = [window.matchMedia("(pointer: coarse)"), window.matchMedia("(hover: none)")];
    const on = () => setTouch(detect());
    mqs.forEach((mq) => mq.addEventListener?.("change", on));
    window.addEventListener("resize", on);
    return () => {
      mqs.forEach((mq) => mq.removeEventListener?.("change", on));
      window.removeEventListener("resize", on);
    };
  }, []);

  return touch;
}
